const accordionItems = document.querySelectorAll('.accordion-item');

accordionItems.forEach((accordion) => {
  const accordionToggle = accordion.querySelector('.accordion-item__toggle'),
        accordionContent = accordion.querySelector('.accordion-item__content');

  const accordionContentHeigh = accordionContent.scrollHeight + 40;

  accordionToggle.addEventListener('click', () => {
    accordion.classList.toggle('accordion-active');

    if(accordion.classList.contains('accordion-active')) {
      accordionContent.style.maxHeight = `${accordionContentHeigh}px`;
    } else {
      accordionContent.style.maxHeight = `0px`;
    }
  })
})